export const FormTypes = {
  DestinationService: 0,
  LanguageTraining: 1,
  InternationalSchooling: 2,
};
